export function getDebugFlag(name) {
    try {
        const raw = localStorage.getItem('debug_flags')
        if (!raw) return false
        const flags = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(flags)
            ? flags.find(f => f.name === name)?.state === true
            : false
    } catch {
        return false
    }
}